<template>
    <LayoutPublic>
        <p class="mb-4">{{textInfo}}</p>
        <div :class="['alert alert-' + validationState]">
            <div v-if="loading">
                <UiSpinner />
                {{confirmLabel}}
            </div>
            <div v-else>
                <div v-if="success">
                    <i class="fa fa-check mr-2"></i>
                    {{confirmSuccessLabel}}
                </div>    
                <div v-else>
                    <i class="fa fa-exclamation-triangle mr-2"></i>
                    {{errorMessage}}
                </div>    
            </div>
        </div>
    </LayoutPublic>
</template>

<script>
    import axios from 'axios'
    import API from '@/services/API.js'
    import LayoutPublic from '@/components/layouts/public'
    import UiSpinner from '@/components/ui/UiSpinner'

    export default {
        name: 'ChannelConfirmation',
        components: {
            LayoutPublic,
            UiSpinner,
        },
        data: () => ({
            loading: true,
            channelType: undefined,
            callId: undefined,
            success: null,
            errorMessage: window.V.$i18n.t('global.error_message'),
            textInfo: window.V.$i18n.t('watchmen.public_validation.info')
        }),

        computed: {
            confirmLabel(){
                return this.channelType === "email" ? 
                    window.V.$i18n.t("watchmen.public_validation.confirmEmail") 
                    : window.V.$i18n.t("watchmen.public_validation.confirmNumber")
            },
            confirmSuccessLabel(){
                return this.channelType === "email" ? 
                    window.V.$i18n.t("watchmen.public_validation.confirmEmailSuccess") 
                    : window.V.$i18n.t("watchmen.public_validation.confirmNumberSuccess")
            },
            validationState() {
                if (this.loading) return "info";
                return this.success ? "success" : "danger";
            }
        },

        methods: {
            confirmChannel: function() {
                axios.defaults.baseURL = API.apiBaseURL
                axios
                    .post(API.route(API.endpoints.public.channelConfirmation), { call_id: this.$route.params.callId })
                    .then(() => {
                        this.success = true;
                    })
                    .catch(({ response }) => {
                        console.log(response.data.message)
                        this.success = false;
                        if (window.V.$i18n.te('watchmen.public_validation.errors.' + response.data.message)) {
                            this.errorMessage = window.V.$i18n.t('watchmen.public_validation.errors.' + response.data.message)
                        }
                    })
                    .finally(() => this.loading = false);
            }
        },

        mounted(){
            this.callId = this.$route.params.callId;
            this.channelType = this.$route.query.channelType ? this.$route.query.channelType : 'sms';
            this.confirmChannel();
        }
    }
</script>

<style lang="scss" scoped>
</style>
